import { render, staticRenderFns } from "./StudentScheduleExamTimes.vue?vue&type=template&id=effdfcb4&"
import script from "./StudentScheduleExamTimes.vue?vue&type=script&lang=js&"
export * from "./StudentScheduleExamTimes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports